import { forwardRef } from "react";

import CentralizedModalContainer from "../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal
} from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

const CustomPickerModal = forwardRef((props, ref) => (
  <CentralizedModalContainer show={props.show}>
    <Modal
      ref={ref}
      show={props.show}
      id="custom-picker-modal"
      minWidth="small"
      maxWidth="medium"
      fillWidth={true}
      centerScreen={true}
    >
      <DialogTitle divider={true} onClose={props.onClose}>
        {`${appstr("New")} ${appstr("customcolor")}`}
      </DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: "6px" }} />
        {props.children}
      </DialogContent>
      <DialogActions>
        <DialogActions.Tertiary onClick={props.onClose} dataTestId={props.cancelTestId}>
          {appstr("Cancel")}
        </DialogActions.Tertiary>
        <DialogActions.Primary onClick={props.onSave} dataTestId={props.saveTestId}>
          {appstr("Save")}
        </DialogActions.Primary>
      </DialogActions>
    </Modal>
  </CentralizedModalContainer>
));

export default CustomPickerModal;
